import {REQUEST_MANAGER_PERSONS, REQUEST_MANAGER_PERSONS_FAILURE, REQUEST_MANAGER_PERSONS_SUCCESS} from "../../../constant/master/TransManagerPersonConstant";

const initialState = {
    manager_persons: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const managerPersonsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_MANAGER_PERSONS:
            return {
                ...state,
                manager_persons: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_MANAGER_PERSONS_SUCCESS:
            return {
                ...state,
                manager_persons: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_MANAGER_PERSONS_FAILURE:
            return {
                ...state,
                manager_persons: {
                    data: [],
                    status: 'idle',
                },
            };
        default:
            return state;
    }
}
